import type { LinkResource } from "api/generated";
import type { Link } from "shared/types";

export const mapLink = (resource: LinkResource): Link => ({
  id: resource.id,
  name: resource.name,
  url: resource.url,
});

export const mapLinks = (resources: LinkResource[]): Link[] =>
  resources.map(mapLink);
